export default {
  en: {
    title: 'Help Center',
  },
  es: {
    title: 'Centro de ayuda',
  },
  fr: {
    title: 'Centre d\'aide',
  }
};
